import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useForm } from 'react-hook-form';
import { Card, H3, H5, Text, TextField, Button, Divider } from '../../../../../components';

import { organizationShape } from '../../../../../propsShape';

const StyledCard = styled(Card)`
  padding: 0;
`;

const Section = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
`;

const StyledH3 = styled(H3)`
  margin-bottom: 4px;
`;

const InputHeader = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  margin-bottom: 8px;
`;

const StyledButton = styled(Button)`
  margin-left: auto;
`;

const OrganizationSettingsForm = ({ currentOrganization, onSubmit }) => {
  const defaultValues = {
    displayName: currentOrganization.displayName,
    description: currentOrganization.description
  };

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting }
  } = useForm({ defaultValues });

  const displayNameInput = register('displayName');
  const descriptionInput = register('description');

  return (
    <StyledCard>
      <Section>
        <StyledH3>Organization Profile</StyledH3>
        <Text $color='var(--content-subtitle)'>
          Customize how your organization appears to Supper AI.
        </Text>
      </Section>
      <Divider padding={0} color='var(--border-muted)' />
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Section>
          <InputHeader>
            <H5>Display name</H5>
          </InputHeader>
          <TextField
            label='Display name'
            placeholder={defaultValues.displayName}
            name={displayNameInput.name}
            onChange={displayNameInput.onChange}
            onBlur={displayNameInput.onBlur}
            ref={displayNameInput.ref}
            error={errors.name?.message}
          />
          <InputHeader>
            <H5>Business description</H5>
            <Text $color='var(--content-subtitle)'>
              Your business context helps the LLM generate better database descriptions.
            </Text>
          </InputHeader>
          <TextField
            label='Description'
            placeholder={defaultValues.description}
            name={descriptionInput.name}
            onChange={descriptionInput.onChange}
            onBlur={descriptionInput.onBlur}
            ref={descriptionInput.ref}
            error={errors.name?.message}
            inputAs='textarea'
          />
        </Section>
        <Divider padding={0} color='var(--border-muted)' />
        <Section>
          <StyledButton type='submit' isSubmitting={isSubmitting} primary>
            Save
          </StyledButton>
        </Section>
      </form>
    </StyledCard>
  );
};

OrganizationSettingsForm.propTypes = {
  currentOrganization: organizationShape.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export { OrganizationSettingsForm };
